import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "row row-cols-2 no-gutters" }
const _hoisted_3 = {
  class: "project_leftside col",
  style: {"justify-content":"center"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "project_rightside d-felx col",
  style: {"flex-direction":"column"}
}
const _hoisted_6 = {
  class: "h5 project_title",
  style: {"margin-left":"0.25rem","margin-bottom":"0"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "project_description col-auto" }
const _hoisted_9 = {
  class: "row",
  style: {"display":"flex"}
}
const _hoisted_10 = {
  key: 0,
  class: "col-6"
}
const _hoisted_11 = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  class: "bi-heart-fill heart_icon b-icon bi",
  fill: "currentColor"
}
const _hoisted_12 = ["xlink:href"]
const _hoisted_13 = {
  key: 1,
  class: "col-6"
}
const _hoisted_14 = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  class: "bi-heart-fill heart_icon b-icon bi"
}
const _hoisted_15 = ["xlink:href"]
const _hoisted_16 = {
  key: 2,
  class: "col-6"
}
const _hoisted_17 = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  class: "bi-eye-fill b-icon bi"
}
const _hoisted_18 = ["xlink:href"]
const _hoisted_19 = {
  key: 3,
  class: "col-6"
}
const _hoisted_20 = {
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em",
  class: "bi-shift-fill b-icon bi"
}
const _hoisted_21 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserBlock = _resolveComponent("UserBlock")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card project_panel",
    style: {"border":"0","margin-bottom":"0.5rem"},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onProjectClick()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "project_image",
            src: _ctx.urls.getThumbnailURL(_ctx.publicPage.user.id, _ctx.publicPage),
            alt: "投稿画像"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.publicPage.title), 1),
          (_ctx.publicPage.user != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_UserBlock, {
                  dtoUser: _ctx.publicPage.user
                }, null, 8, ["dtoUser"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.publicPage.description), 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.publicPage.createdAt), 1),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.publicPage.goodCount != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_11, [
                      _createElementVNode("use", {
                        "xlink:href": _ctx.urls.getIconURL('heart-fill-pink')
                      }, null, 8, _hoisted_12)
                    ])),
                    _createTextVNode(" " + _toDisplayString(_ctx.publicPage.goodCount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.publicPage.commentsCount != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                      _createElementVNode("use", {
                        "xlink:href": _ctx.urls.getIconURL('chatleft')
                      }, null, 8, _hoisted_15)
                    ])),
                    _createTextVNode(" " + _toDisplayString(_ctx.publicPage.commentsCount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.publicPage.viewCount != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_17, [
                      _createElementVNode("use", {
                        "xlink:href": _ctx.urls.getIconURL('eye-fill')
                      }, null, 8, _hoisted_18)
                    ])),
                    _createTextVNode(" " + _toDisplayString(_ctx.publicPage.viewCount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.publicPage.anonymousGoodCount != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                      _createElementVNode("use", {
                        "xlink:href": _ctx.urls.getIconURL('shift-fill')
                      }, null, 8, _hoisted_21)
                    ])),
                    _createTextVNode(" " + _toDisplayString(_ctx.publicPage.anonymousGoodCount), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}